import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { userRolesDictionary } from '../shared/authorization/userRoles';
import { singleAssignmentPropTypes, userClientPropTypes } from '../shared/propTypes/userClients';
import PermissionsForm from '../shared/forms/permissions/permissionsForm.component';

import { getPermissionsByRoleAndClientSelector } from './addEditUserSettingsForm.helpers';
import {
  availablePermissionsPropTypes,
  clientRolePropTypes,
} from './propTypes';

export default class UserPrivilegesTab extends PureComponent {
  static propTypes = {
    availablePermissions: availablePermissionsPropTypes.isRequired,
    changePermissions: PropTypes.func.isRequired,
    isLoadingDataToEdit: PropTypes.bool,
    readOnly: PropTypes.bool.isRequired,
    selectedClient: PropTypes.shape({
      clientId: PropTypes.number.isRequired,
    }),
    selectedPermissionsFormValue: PropTypes.arrayOf(PropTypes.string),
    selectedRole: PropTypes.shape({
      clientId: PropTypes.number.isRequired,
      name: PropTypes.string,
    }),
    shouldResetValues: PropTypes.bool.isRequired,
    defaultClient: userClientPropTypes,
    defaultClientRole: clientRolePropTypes,
    roleBasedPermissions: PropTypes.shape({}),
    loggedInUserPermissions: PropTypes.shape({}),
    checkedAssignments: PropTypes.arrayOf(singleAssignmentPropTypes).isRequired,
    changeAssignmentsPermissions: PropTypes.func.isRequired,
    availableAssignmentPermissions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      requiresPermissions: PropTypes.arrayOf(PropTypes.string),
    })).isRequired,
  };

  static defaultProps = {
    isLoadingDataToEdit: false,
    roleErrorMessage: '',
    roleBasedPermissions: {},
  };

  render() {
    const {
      availablePermissions,
      changePermissions,
      readOnly,
      selectedClient,
      selectedPermissionsFormValue,
      selectedRole,
      shouldResetValues,
      defaultClient,
      defaultClientRole,
      roleBasedPermissions,
      checkedAssignments,
      changeAssignmentsPermissions,
      availableAssignmentPermissions,
      loggedInUserPermissions,
    } = this.props;

    const defaultClientRoleName = defaultClientRole ? defaultClientRole.name : '';

    return (
      <div>
        <div className="row">
          <div className="col-12 col-md-2">
            <div className="user-client-label">
              {`Client: ${defaultClient.name}`}
            </div>
          </div>
          <div className="col-12 col-md-2">
            <div className="user-role-label">
              {`Role: ${userRolesDictionary[defaultClientRoleName] || defaultClientRoleName}`}
            </div>
          </div>
        </div>

        <br />
        <PermissionsForm
          readOnly={readOnly}
          selectedClient={selectedClient}
          selectedRole={selectedRole}
          availablePermissions={availablePermissions}
          loggedInUserPermissions={loggedInUserPermissions}
          shouldResetValues={shouldResetValues}
          selectedPermissionsFormValue={selectedPermissionsFormValue}
          changePermissions={changePermissions}
          getPermissionsFunction={getPermissionsByRoleAndClientSelector}
          roleBasedPermissions={roleBasedPermissions}
          checkedAssignments={checkedAssignments}
          changeAssignmentsPermissions={changeAssignmentsPermissions}
          availableAssignmentPermissions={availableAssignmentPermissions}
        />
      </div>
    );
  }
}
